var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.45143V8.00343C13.9993 9.29729 13.5803 10.5562 12.8056 11.5925C12.0309 12.6288 10.942 13.3869 9.70121 13.7538C8.46046 14.1206 7.13435 14.0766 5.92068 13.6282C4.70701 13.1798 3.67079 12.3511 2.96658 11.2657C2.26236 10.1803 1.92787 8.89627 2.01301 7.60522C2.09814 6.31417 2.59832 5.08523 3.43897 4.10168C4.27961 3.11813 5.41567 2.43266 6.67771 2.14752C7.93975 1.86238 9.26016 1.99284 10.442 2.51943M14 3.20343L8 9.20943L6.2 7.40943",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-circle.365b2e40e0b65b7af5a4a240f90327fb.svg";